import type { EnrollmentStatus } from "@/lib/api/enrollments";

/** The roster's word for each enrollment status, wherever a status is named. */
export const ENROLLMENT_STATUS_LABEL: Record<EnrollmentStatus, string> = {
  enrolled: "Enrolled",
  withdrawn: "Withdrawn",
  complete: "Complete",
  incomplete: "Incomplete",
};
